/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetAiBudgetQueryResponse, GetAiBudgetPathParams, GetAiBudget400, GetAiBudget401, GetAiBudget403, GetAiBudget404, GetAiBudget409, GetAiBudget500 } from "../../types/platformBillingController/GetAiBudget.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetAiBudgetUrl(organizationId: GetAiBudgetPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/platform-billing/ai-budget` as const }
  return res
}

/**
 * @summary Get AI budget breakdown (plan + top-up credits, native currency)
 * {@link /api/organizations/:organizationId/platform-billing/ai-budget}
 */
export async function getAiBudget(organizationId: GetAiBudgetPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetAiBudgetQueryResponse, ResponseErrorConfig<GetAiBudget400 | GetAiBudget401 | GetAiBudget403 | GetAiBudget404 | GetAiBudget409 | GetAiBudget500>, unknown>({ method : "GET", url : getGetAiBudgetUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}